import React, { useEffect } from 'react';
import { Error } from 'components/error/Error';
import GridNew from 'components/grid/GridNew';
import { Loader } from 'components/loader/Loader';
import { STATUSES } from 'core/api';
import { withModalsFC } from 'core/modals/ModalsProvider';
import { gridConfig } from './config';
import { IProps } from './interfaces';
import { fetchArticles, removeArticle } from './redux';
import { IWithModalProps } from 'core/modals/interfaces';
import { MODALS } from 'core/modals/config';
import { toast } from 'react-toastify';

import styles from './Articles.module.styl';
import { useAppDispatch, useAppSelector } from 'core/store/createStore';

const Articles: React.FC<IProps & IWithModalProps> = ({
  history,
  openModal,
  location: { search, hash },
}) => {
  const searchPhrase = hash ? hash.split('#')[1] : '';
  const { articles } = useAppSelector(state => state);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      fetchArticles({
        hash,
        search,
      }),
    );
    // eslint-disable-next-line
  }, [search, hash]);

  const handleSearch = (searchPhrase: string) => {
    history.push(`/admin/articles#${searchPhrase}`);
  };

  const removeArticleItem = async (id: string) => {
    openModal(MODALS.CONFIRM, {
      caption: 'Warning',
      onConfirm: async () => {
        try {
          await dispatch(removeArticle(id));
          dispatch(fetchArticles({ search, hash }));
          toast.success('Success!');
        } catch (error) {
          const { message } = error as Error;
          toast.error(message);
        }
      },
      text: 'Are you sure you want to delete this article?',
    });
    return;
  };
  switch (articles.status) {
    case STATUSES.REQUEST:
      return <Loader />;
    case STATUSES.FAILED:
      return <Error>{articles.error}</Error>;
    case STATUSES.SUCCESS:
      return (
        <div className={styles.root}>
          <GridNew
            data={articles.data.items}
            config={gridConfig}
            urlPrefix="/admin/articles"
            removeItem={removeArticleItem}
            pagination={articles.data.pagination}
            onSearch={handleSearch}
            searchPhrase={searchPhrase}
          />
        </div>
      );
    default:
      return null;
  }
};

export default withModalsFC<IProps>(Articles);
